import { ComponentProps, FC, ReactNode } from 'react';
import { Box, Stack } from '@mui/material';
import { Breadcrumbs } from 'melp-design/components';

interface Props {
  breadcrumbs: ComponentProps<typeof Breadcrumbs>['items'];
  under?: ReactNode;
  side?: ReactNode;
}

export const PageHeaderLayout: FC<Props> = ({ side, under, breadcrumbs }) => {
  return (
    <Stack mb={2} flexDirection="row" justifyContent="space-between" gap={2}>
      <Stack gap={0.5}>
        <Breadcrumbs items={breadcrumbs} />
        {under ? <Box>{under}</Box> : null}
      </Stack>

      <Box>{side}</Box>
    </Stack>
  );
};
